import React, { useState } from 'react'
import { constants, Icon } from '@adc/ui-adc'
import { search } from '@adc/blueprint'
import classnames from 'classnames/bind'
import styles from './styles.scss'
import SortDropdown from '../sortDropdown'
const cx = classnames.bind(styles)

const { ColorNames } = constants

interface ListHeadersProps {
  elmId: string
  featureFlags: any
  filters: { sort: { type: any; order: string } }
  updateSorting: (value: { type: any; order: string }) => void
}

const ListHeaders = ({
  elmId,
  featureFlags,
  filters,
  updateSorting,
}: ListHeadersProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const updateSortingAction = (value: string) => {
    const updatedSortValue = search.sorting.utils.getUpdatedSortObject(
      value,
      filters
    )
    updateSorting({ ...updatedSortValue, order: updatedSortValue.order || '' })
  }

  const getSortDropdownTitle = (selectedValue: string) => {
    const selectedOrder = search.sorting.constants.ARVSortOptionsOrder.find(
      option => option.value === selectedValue
    )

    return (
      <>
        <span className={cx('sort-label')}>Sort:</span>
        <span className={cx('sort-selection')}>
          {selectedOrder?.text || ''}
        </span>
        <Icon
          color={ColorNames.Info}
          iconStyle='solid'
          name={dropdownOpen ? 'chevron-up' : 'chevron-down'}
          size='small'
        />
      </>
    )
  }

  const onOpen = () => setDropdownOpen(true)

  const onClose = () => setDropdownOpen(false)

  const { type: sortType, order: sortOrder } = filters.sort
  const mappedSortValue = search.sorting.utils.mapSortValue(sortType, sortOrder)

  return (
    <div data-elm-id={elmId} className={cx('asset-headers-root')}>
      <div className={cx('sort-container')}>
        <SortDropdown
          elmId={elmId}
          featureFlags={featureFlags}
          onClose={onClose}
          onOpen={onOpen}
          onSelect={updateSortingAction}
          selectedDirection={sortOrder}
          selectedValue={mappedSortValue}
          title={getSortDropdownTitle(mappedSortValue)}
        />
      </div>
    </div>
  )
}

export default ListHeaders
